import * as React from 'react'
import { Button, SECONDARY_BUTTON, SIZE_SMALL } from '@mds/mds-reactjs-library'
import './FirmMemberLoginSection.css'
import { classes } from './ViewLayout'
import type { AuthState } from '../types/AuthState'
import { loginAsFirmMember } from '../util/loginActions'

type FirmMemberLoginSectionProps = {
  authState: AuthState
  jwt: string
}

const FirmMemberLoginSection = ({ authState, jwt }: FirmMemberLoginSectionProps): JSX.Element => (
  <div className={classes.firmMemberAuthBlock}>
    <div className={classes.orDivider} role="presentation">
      <span className={classes.orDividerRule} />
      <span className={classes.orDividerLabel}>or</span>
      <span className={classes.orDividerRule} />
    </div>
    <div className={classes.firmMemberButtonWrap}>
      <Button
        type="button"
        onClick={() => loginAsFirmMember({ authState, jwt })}
        className={`${classes.ctaButton} ${classes.firmMemberButton}`}
        appearance={SECONDARY_BUTTON}
        size={SIZE_SMALL}
      >
        Sign in with McKinsey SSO
      </Button>
    </div>
  </div>
)

export default FirmMemberLoginSection
